var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLungs1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.238,
    height: 60.238,
    viewBox: "0 0 60.238 60.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-1327.6 -358.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(1329 360)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4-2",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_15",
    "data-name": "Stroke 15",
    d: "M0,28.719A28.719,28.719,0,1,1,28.719,57.438,28.719,28.719,0,0,1,0,28.719Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#33f",
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_19",
    "data-name": "Fill 19",
    d: "M35.132,30.916H29.511a7.034,7.034,0,0,1-7.026-7.025V18.845l-2.812-2.81-2.81,2.81v5.045a7.034,7.034,0,0,1-7.027,7.025H4.216A4.22,4.22,0,0,1,0,26.7V21.08A12.647,12.647,0,0,1,12.647,8.432a4.221,4.221,0,0,1,4.217,4.216v2.235l1.4-1.4V1.406a1.405,1.405,0,1,1,2.811,0V13.478l1.406,1.4V12.648A4.22,4.22,0,0,1,26.7,8.432,12.648,12.648,0,0,1,39.348,21.08V26.7A4.22,4.22,0,0,1,35.132,30.916ZM26.7,11.243a1.407,1.407,0,0,0-1.406,1.4V23.891a4.221,4.221,0,0,0,4.216,4.216h5.621a1.407,1.407,0,0,0,1.406-1.4V21.08A9.848,9.848,0,0,0,26.7,11.243Zm-14.054,0A9.848,9.848,0,0,0,2.81,21.08V26.7a1.407,1.407,0,0,0,1.406,1.4h5.62a4.221,4.221,0,0,0,4.217-4.216V12.648A1.407,1.407,0,0,0,12.647,11.243Z",
    transform: "translate(9.046 11.902)",
    fill: "#33f"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLungs1);
export default __webpack_public_path__ + "static/media/lungs_1.ee3189e3cff71e272e6266764bd159d7.svg";
export { ForwardRef as ReactComponent };